import { render, staticRenderFns } from "./Rail.vue?vue&type=template&id=2f19b0f1&scoped=true"
import script from "./Rail.js?vue&type=script&lang=js&external"
export * from "./Rail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19b0f1",
  null
  
)

export default component.exports